import React, {useMemo} from 'react';
import {useDrag} from 'react-dnd';
import {BaseDragableLayoutProps, DragableItem} from '../types';
import {useBaseLayoutProps} from '../hooks/useBaseLayoutProps';
import {injectGlobalStyle} from '../../base/functions';

export const BaseDragableLayout = function <TItem extends DragableItem>(
  props: React.PropsWithChildren<BaseDragableLayoutProps<TItem>>,
) {
  const {
    type,
    item,
    enabled = true,
    onBeginDrag,
    onEndDrag,
    onPress,
    onBlur,
    disabled,
    children,
  } = props;

  const itemWithType = useMemo(() => ({...item, type}), [item, type]);
  const [, drag] = useDrag(
    () => ({
      item: itemWithType,
      begin: () => {
        //console.log('BaseDragableLayout: begin');
        onBeginDrag && onBeginDrag(itemWithType);
        return itemWithType;
      },
      end: (_, monitor) => {
        //console.log('BaseDragableLayout: end');
        onEndDrag && onEndDrag(itemWithType, monitor.didDrop());
      },
    }),
    [item],
  );

  const {classNameProp, handleClick} = useBaseLayoutProps(props);
  classNameProp.className = classNameProp.className + ' di-div-dragable';

  return onPress ? (
    <button
      ref={enabled ? drag : undefined}
      {...classNameProp}
      disabled={disabled}
      onClick={handleClick}
      onBlur={onBlur}>
      {children}
    </button>
  ) : (
    <div ref={enabled ? drag : undefined} {...classNameProp} onBlur={onBlur}>
      {children}
    </div>
  );
};

// Use 'grab' cursor for dragable layouts
injectGlobalStyle({
  default: {
    '*.di-div-dragable': {
      cursor: 'grab',
    },
  },
});
